import { StyleRules, Theme } from '@material-ui/core';
import { ROOT } from '../../../constants/routes';
const img = `${ROOT}/Auth/space.jpg`;

export default (theme: Theme): StyleRules => ({
  circle: {
    [theme.breakpoints.up('md')]: {
      backgroundImage: '',
      left: '-2vh',
      top: '17vh',
    },
    [theme.breakpoints.only('sm')]: {
      right: '-6vh',
      top: '10vh',
    },
    [theme.breakpoints.only('xs')]: {
      backgroundImage: `url(${img})`,
      height: '35vh',
      right: '-21vh',
      top: '8vh',
      width: '35vh',
    },
    backgroundColor: '#2E83D9',
    borderRadius: '50%',
    height: '15vh',
    position: 'absolute',
    width: '15vh',
    zIndex: 0,
  },
  imgGrid: {
    [theme.breakpoints.up('md')]: {
      position: 'relative',
    },
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
    },
  },
  right: {
    [theme.breakpoints.up('xl')]: {
      maxHeight: '90%',
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      display: 'block',
      minHeight: '85vh',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
    borderRadius: '5%',
    height: 'auto',
    position: 'absolute',
  },
  root: {
    [theme.breakpoints.up('md')]: {
      padding: `${56 - theme.spacing(5)}px ${64 - theme.spacing(5)}px`,
    },
    [theme.breakpoints.down('sm')]: {
      padding: '32px 32px',
    },
    '& .MuiInputBase-root': {
      height: '100%',
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(14px, 27px) scale(1)',
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, 5px) scale(0.75)',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '2px',
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderWidth: '3px',
    },
    '& input': {
      outline: 'none',
      padding: '23px 10px 12px 13px',
    },
    '& label.Mui-focused': {
      color: '#1C8ED9',
    },
    '& legend': {
      width: 0,
    },
    backgroundColor: '#1a1b2b',
    color: '#1C8ED9',
    height: '100%',
    margin: '0',
    minHeight: '100vh',
    overflow: 'hidden',
    position: 'relative',
    textDecoration: 'none',
    width: '100%',
  },
  spacing: {
    '& > *': {
      [theme.breakpoints.up('sm')]: {
        padding: '40px',
      },
      [theme.breakpoints.down('xs')]: {
        padding: 0,
      },
    },
  },
  square: {
    [theme.breakpoints.up('md')]: {
      left: '-6vh',
      top: '14vh',
    },
    [theme.breakpoints.only('sm')]: {
      right: '7vh',
      top: '6vh',
    },
    [theme.breakpoints.only('xs')]: {
      height: '11vh',
      right: '10vh',
      top: '6vh',
      width: '11vh',
    },
    backgroundColor: '#0C1F5D',
    borderTopRightRadius: '50%',
    height: '7vh',
    position: 'absolute',
    width: '7vh',
    zIndex: 0,
  },
});
